module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Bold-08572cadf1e4f8b6900f14a37a2ea960.svg";